import { render, staticRenderFns } from "./detailsSCLI.vue?vue&type=template&id=b4e61ab0&scoped=true&"
import script from "./detailsSCLI.vue?vue&type=script&lang=js&"
export * from "./detailsSCLI.vue?vue&type=script&lang=js&"
import style0 from "./detailsSCLI.vue?vue&type=style&index=0&id=b4e61ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e61ab0",
  null
  
)

component.options.__file = "detailsSCLI.vue"
export default component.exports